<template>
  <div class="sidebar-menu">
    <a href="/" class="logo">
      <img alt="logo" src="../assets/logo_white.svg" width="250">
    </a>
    <div v-if="showLogo" class="company-logo">
      <span>for</span>
      <img alt="logo" :src="this.previewUrl(currentOrg.logo_url)">
    </div>

    <ul>
      <li>
        <router-link to="/">
          <img alt="Home" src="../assets/sidebar-icons/home.svg">
          <img alt="Home" src="../assets/sidebar-icons/home_active.svg" class="active-img">
          <span>{{$t('sidebar.home')}}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/folders" active-class='active'>
          <img src="../assets/sidebar-icons/folders_active.svg" class="active-img">
          <img src="../assets/sidebar-icons/folders.svg">
          <span>{{$t('sidebar.my_relatico')}}</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'shared_folder_index' }" active-class='active'>
          <img alt="Shared Folders" src="../assets/sidebar-icons/shared_active.svg" class="active-img">
          <img alt="Shared Folders" src="../assets/sidebar-icons/shared.svg">
          <span>{{$t('sidebar.shared_with_me')}}</span>
        </router-link>
      </li>
      <li v-if="toggles('my_shared_folders')">
        <router-link :to="{ name: 'my_shared_folders_index' }" active-class='active'>
          <img alt="My shared folders" src="../assets/sidebar-icons/shared_folders_active.svg" class="active-img">
          <img alt="My shared folders" src="../assets/sidebar-icons/shared_folders.svg">
          <span>{{$t('sidebar.shared_folders')}}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/document_types" active-class='active'>
          <img alt="Document Types" src="../assets/sidebar-icons/document-types_active.svg" class="active-img">
          <img alt="Document Types" src="../assets/sidebar-icons/document-types.svg">
          <span>{{userDocumentTypeTitle}}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/products" active-class='active'>
          <img alt="Products" src="../assets/sidebar-icons/products_active.svg" class="active-img">
          <img alt="Products" src="../assets/sidebar-icons/products.svg">
          <span>{{userProductTitle}}</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'contactIndex' }" active-class='active'>
          <img alt="Contacts" src="../assets/sidebar-icons/contact_active.svg" class="active-img">
          <img alt="Contacts" src="../assets/sidebar-icons/contact.svg">
          <span>{{$t('sidebar.contacts')}}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/calendar" active-class='active'>
          <img alt="Calendar" src="../assets/sidebar-icons/reminder-active.svg" class="active-img">
          <img alt="Calendar" src="../assets/sidebar-icons/reminder.svg">
          <span>{{$t('sidebar.calendar')}}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/tags" active-class='active'>
          <img alt="Tags" src="../assets/sidebar-icons/tag.svg">
          <img alt="Tags" src="../assets/sidebar-icons/tag_active.svg" class="active-img">
          <span>{{$t('sidebar.tags')}}</span>
        </router-link>
      </li>
      <li>
        <router-link to="/deleted" active-class='active'>
          <img alt="Deleted Folders" src="../assets/sidebar-icons/deleted-files_active.svg" class="active-img">
          <img alt="Deleted Folders" src="../assets/sidebar-icons/deleted-files.svg">
          <span>{{$t('sidebar.deleted')}}</span>
        </router-link>
      </li>

      <li>
        <router-link to="/communication" active-class='active' class="disabled">
          <img alt="Communication" src="../assets/sidebar-icons/envelope-active.svg" class="active-img">
          <img alt="Communication" src="../assets/sidebar-icons/envelope.svg">
          <span>{{ $t('sidebar.communication') }}</span>
        </router-link>

        <ul>
          <li v-if="toggles('file_communication')">
            <router-link :to="{ name: 'record_message' }" active-class='active'>
              <img src="../assets/sidebar-icons/record_messages_active.svg" class="active-img">
              <img src="../assets/sidebar-icons/record_messages.svg">
              <span>{{ $t('sidebar.interactive_notes') }}</span>
              <span v-show="messageStats > 0" class="messages-count">
                {{ messageStats }}
              </span>
            </router-link>
          </li>
          <li>
            <router-link to="/communication/inbox" active-class='active'>
              <img alt="Received messages" src="../assets/sidebar-icons/envelope-active.svg" class="active-img">
              <img alt="Received messages" src="../assets/sidebar-icons/envelope.svg">
              <span>{{ $t('sidebar.received_messages') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/communication/sent" active-class='active'>
              <img alt="Sent" src="../assets/sidebar-icons/send-emails-active.svg" class="active-img">
              <img alt="Sent" src="../assets/sidebar-icons/send-emails.svg">
              <span>{{ $t('sidebar.sent_messages') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/communication/attachments" active-class='active'>
              <img alt="Attachments" src="../assets/sidebar-icons/attachments-active.svg" class="active-img">
              <img alt="Attachments" src="../assets/sidebar-icons/attachments.svg">
              <span>{{ $t('sidebar.attachments') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/communication/future-emails" active-class='active'>
              <img alt="Scheduled Emails" src="../assets/sidebar-icons/scheduled_emails-active.svg" class="active-img">
              <img alt="Scheduled Emails" src="../assets/sidebar-icons/scheduled_emails.svg">
              <span>{{ $t('sidebar.scheduled_messages') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/communication/automated-emails" active-class='active'>
              <img alt="Automated Emails" src="../assets/sidebar-icons/automated-emails-active.svg" class="active-img">
              <img alt="Automated Emails" src="../assets/sidebar-icons/automated-emails.svg">
              <span>{{ $t('sidebar.automated_emails') }}</span>
            </router-link>
          </li>
          <li>
            <router-link to="/communication/trash" active-class='active'>
              <img alt="Bin" src="../assets/sidebar-icons/bin-active.svg" class="active-img">
              <img alt="Bin" src="../assets/sidebar-icons/bin.svg">
              <span>{{ $t('sidebar.bin') }}</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li v-if='currentUser.super_admin'>
        <router-link :to="{ name: 'login_as' }" active-class='active'>
          <span>Login as</span>
        </router-link>
      </li>
    </ul>

    <div class="footer">
      <p>
        <i class="fa fa-lock"></i>
        {{$t('sidebar.privacy')}}
      </p>
      <a target="false" :href='helpCenterUrl'>{{ $t('public.help_center')}}</a>
      <p>© {{new Date().getFullYear()}} relatico.</p>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Sidebar",
    computed: {
      helpCenterUrl() {
        return this.locale === 'de' ? 'https://support.relatico.com/de/' : 'https://support.relatico.com/en/'
      },
      showLogo(){
        return this.previewUrl(this.currentOrg.logo_url)
      },
      messageStats() {
        return (this.replies.length + this.newMessages.length)
      },
      replies(){
        return this.fileCommunicationStats.replies || []
      },
      newMessages(){
        return this.fileCommunicationStats.new_messages || []
      },
      fileCommunicationStats() {
        return this.stats.fileCommunicationStats || {}
      }
    },
    watch:{
      query(){
        this.updateCommunicationStats()
      }
    },
    methods: {
      updateCommunicationStats(){
        if(this.toggles('file_communication')){
          this.statStore.getCommunicationMessagesStats({
            'filters[to_user_id]': this.currentUser.id
          }, true)
        }
      }
    }
  }
</script>

<style lang="sass" scoped>
  @import "../styles/sidebar"
</style>
